export type ShapePose = 'standing' | 'hunched' | 'cactus' | 'star' | 'sitting' | 'laying' | 'ball';
export type ShapeTone = 'accent' | 'ink' | 'muted' | 'faint';

/** Inner-page figure by route — pose matches the page’s job. */
export function shapeForPath(path: string): { pose: ShapePose; tone: ShapeTone } | null {
  if (path === '/' || path === '') return null;
  if (path.startsWith('/projects')) return { pose: 'star', tone: 'accent' };
  if (path.startsWith('/blog')) return { pose: 'sitting', tone: 'muted' };
  if (path.startsWith('/devis')) return { pose: 'cactus', tone: 'accent' };
  if (path.startsWith('/services')) return { pose: 'hunched', tone: 'accent' };
  if (path.startsWith('/villes')) return { pose: 'standing', tone: 'ink' };
  if (path.startsWith('/terms') || path.startsWith('/privacy') || path.startsWith('/legal')) {
    return { pose: 'laying', tone: 'faint' };
  }
  return { pose: 'ball', tone: 'muted' };
}
